import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import RowItem from "./RowItem";
import RowItemMobile from "./RowItemMobile";

const CardBody = ({
  data,
  linkTitle,
  fetchLearningModuleData,
  sliceData = true,
}: {
  data: any;
  linkTitle?: any;
  fetchLearningModuleData: any;
  sliceData?: boolean;
}) => {
  const [records, setRecords] = useState<any>([]);

  useEffect(() => {
    if (sliceData) {
      setRecords(data?.slice(0, 6));
    } else {
      setRecords(data);
    }
  }, [data]);

  return (
    <>
      <div className="desk">
        <Row style={styles.rowBg}>
          {data.length > 0 ? (
            records.map((item: any) => {
              return (
                <RowItem
                  item={item}
                  linkTitle={linkTitle}
                  fetchLearningModuleData={fetchLearningModuleData}
                />
              );
            })
          ) : (
            <span style={styles.text1}>No records found</span>
          )}
        </Row>
      </div>

      <div className="mob px-0" style={{ marginTop: "0px" }}>
        <Row style={styles.rowBgMob}>
          {records?.length > 0 ? (
            records?.map((item: any) => {
              return <RowItemMobile item={item} linkTitle={linkTitle} />;
            })
          ) : (
            <span style={styles.text1}>No records found</span>
          )}
        </Row>
      </div>
    </>
  );
};

const styles: any = {
  borderRadius: {
    borderRadius: "50%",
  },
  rowBg: {
    backgroundColor: "#ffffff",
    paddingTop: "16px",
    paddingBottom: "0px",
    // margin: "auto",
  },
  rowBgMob: {
    backgroundColor: "#ffffff",
    // paddingTop: "16px",
    paddingBottom: "0px",
  },
  text1: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "center",
  },
};

export default CardBody;
